import React from 'react';

import './styles.css';

const XIcon = () => (
  <svg
    className="icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1200 1227"
  >
    <g id="Layer_2" data-name="Layer 2">
      <path
        style={{ fill: '#fff' }}
        d="M714.1 558.8L1166.2 0h-105.6L663.1 497.2 312.7 0H0l481.9 686.3L0 1227h105.6l428.5-518.2 370.8 518.2H1200L714.1 558.8zM600.6 733.3L543.3 657 141.8 71.3h134.6l332.8 464.9 57.3 76.4 420.9 588.3H952L600.6 733.3z"
      />
    </g>
  </svg>
);

export default XIcon;
